import {SAME_CHORD, NEW_CHORD, OCTAVE_UP, OCTAVE_DOWN, TWO_OCTAVES_UP, TWO_OCTAVES_DOWN, CHORD_ON_EVENT, CHORD_OFF_EVENT} from 'chords/constants.js';
import Notes from 'midi/Notes.js';

class ChordsManager {
    constructor() {
        this.addListeners();
        this.currentChord = undefined;
        this.lastChordTime = undefined;
        this.newChordListeners = [];
        this.sameChordListeners = [];
        this.octaveUpListeners= [];
        this.octaveDownListeners= [];
    }

    addListeners() {
        return;
        window.addEventListener(
            CHORD_ON_EVENT,
            (event) => {
                this.chordOn(event.notesDown);
            });

        window.addEventListener(
            CHORD_OFF_EVENT,
            (event) => {
                this.chordOff(event.notesDown);
            });
    }

    setCurrentChord(currentChord) {
        this.currentChord = currentChord;
        this.lastChordTime = new Date().getTime();
    }

    chordOn(newChord) {
        // not used anymore
        return;

        // compare current chord to new chord
        if (this.currentChord === undefined) {
        } else if (this.isSameChord(this.currentChord, newChord)) {
            this.sameChord();
        } else if (this.isOctaveUp(this.currentChord, newChord)) {
            this.octaveUp(newChord);
        } else if (this.isOctaveDown(this.currentChord, newChord)) {
            this.octaveDown(newChord);
        } else if (this.isOctaveDown(this.currentChord, newChord, 2)) {
            this.twoOctavesDown(newChord);
        } else if (this.isOctaveUp(this.currentChord, newChord, 2)) {
            this.twoOctavesUp(newChord);
        } 

        if (this.currentChord === undefined || 
            !(this.chordContains(this.currentChord, newChord)) &&
              !this.isSameChord(this.currentChord, newChord)) {
            this.newChord(newChord);
        }
    }

    dispatchEvent(eventName) {
        let event = new Event(eventName);
        event.chord = this.currentChord;
        window.dispatchEvent(event);
    }

    sameChord() {
        this.dispatchEvent(SAME_CHORD);
    }

    octaveDown(chord) {
        this.dispatchEvent(OCTAVE_DOWN);
    }

    twoOctavesDown(chord) {
        this.dispatchEvent(TWO_OCTAVES_DOWN);
    }

    octaveUp(chord) {
        this.dispatchEvent(OCTAVE_UP);
    }

    twoOctavesUp(chord) {
        this.dispatchEvent(TWO_OCTAVES_UP);
    }

    newChord(newChord) {
        this.setCurrentChord(newChord);

        this.dispatchEvent(NEW_CHORD);
    }

    stripOctave(chord) {
        return new Set(Array.from(chord)
                               .map(note => Notes.fromString(note).note));
    }
    
    chordContains(currentChord, newChord) {
        currentChord = this.stripOctave(currentChord);
        newChord = this.stripOctave(newChord);

        for (var a of newChord) {
            if (!currentChord.has(a)) {
                return false;
            }
        }

        return true;
    }

    isOctaveUp(currentChord, newChord, octaves=1) {
        let ret = true;
        for (var a of currentChord) {
            var note = Notes.fromString(a).addTranspose(12 * octaves)
                .toString();
            if (!newChord.has(note)) {
                ret = false;
            }
        }

        return ret;
    }

    isOctaveDown(currentChord, newChord, octaves=1) {
        let ret = true;
        for (var a of currentChord) {
            var note = Notes.fromString(a).addTranspose(-12 * octaves)
                .toString();
            if (!newChord.has(note)) {
                ret = false;
            }
        }

        return ret;
    }

    isSameChord(currentChord, newChord) {
        return this.eqSet(currentChord, newChord);
    }

    eqSet(as, bs) {
        if (as.size !== bs.size) return false;
        for (var a of as) if (!bs.has(a)) return false;
        return true;
    }

    chordOff(notes) {
    }

    addCallback() {
        // when the events trigger call this 
    }
}

export default ChordsManager;
